import { render, staticRenderFns } from "./VComponent.vue?vue&type=template&id=0c978362&"
import script from "./VComponent.vue?vue&type=script&lang=js&"
export * from "./VComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports